import React from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import { X } from "lucide-react";

export default function RewardPresentation({ reward, onClose }) {
  const { t } = useTranslation();
  if (!reward) return null;
  const fallback = `${process.env.PUBLIC_URL}/images/game/${reward.type === "voucher" ? "voucher" : "coin"}.webp`;
  return createPortal(
    <div className="shake-sheet-overlay" role="presentation">
      <div
        className="shake-reward-sheet"
        role="dialog"
        aria-modal="true"
        aria-labelledby="shake-reward-title"
      >
        <button
          className="shake-sheet-close"
          onClick={onClose}
          aria-label={t("common.close")}
        >
          <X size={22} aria-hidden="true" />
        </button>
        {!reward.pending && (
          <div className="shake-confetti" aria-hidden="true">
            {Array.from({ length: 8 }, (_, i) => (
              <i key={i} />
            ))}
          </div>
        )}
        {!reward.pending && reward.type === "token" && (
          <div className="shake-coin-burst" aria-hidden="true">
            {Array.from({ length: 8 }, (_, i) => (
              <img
                key={i}
                src={`${process.env.PUBLIC_URL}/images/game/coin.webp`}
                alt=""
                style={{
                  "--burst-x": `${Math.round(Math.cos((i * Math.PI) / 4) * 100)}px`,
                  "--burst-y": `${Math.round(Math.sin((i * Math.PI) / 4) * 85)}px`,
                }}
              />
            ))}
          </div>
        )}
        <div className="shake-prize-art">
          <img
            src={reward.imageUrl || fallback}
            alt=""
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = fallback;
            }}
          />
        </div>
        <h2 id="shake-reward-title">
          {reward.pending
            ? t("reward.processingTitle")
            : t("reward.congratulations")}
        </h2>
        {reward.type === "token" && !!reward.amount && (
          <strong className="shake-prize-amount">+{reward.amount}</strong>
        )}
        <p>
          {reward.pending
            ? t("reward.processing", { name: reward.name })
            : reward.type === "voucher"
              ? t("reward.wonVoucher", { name: reward.name })
              : t("reward.wonToken", {
                  amount: reward.amount,
                  name: reward.name,
                })}
        </p>
        <button className="shake-game-button" onClick={onClose}>
          {t("common.done")}
        </button>
      </div>
    </div>,
    document.body,
  );
}
